import React, { useState } from "react";
import PropTypes from "prop-types";
import { Button, Modal, ModalBody, ModalFooter, Spinner } from "reactstrap";

import { connect } from "react-redux";
import { getMedicalServices, deleteMService } from "../../actions/mservices";

import TableItemActions from "../TableItemActions";
import TableRow from "../styles/TableRow";

const ServicesItem = ({
  service,
  getMedicalServices,
  deleteMService,
  filters
}) => {
  const [modal, setModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [localLoader, setLocalLoader] = useState(false);

  const toggle = () => {
    setModal(!modal);
  };

  const handleDelete = async () => {
    setLoading(true);
    setLocalLoader(true);

    const response = await deleteMService(service.id);

    if (response !== 204) {
      setLocalLoader(false);
      setLoading(false);
      setModal(false);
      return;
    }

    await getMedicalServices(filters);
  };

  return (
    <TableRow localLoader={localLoader}>
      <td>{service.description}</td>
      <td>
        <TableItemActions
          pathName="medical_services"
          id={service.id}
          toggle={toggle}
        />
        <Modal isOpen={modal} centered>
          <ModalBody>
            <h3 className="text-center">
              {loading ? "Eliminando" : "Se eliminará este servicio médico"}
            </h3>
          </ModalBody>
          <ModalFooter>
            {loading ? (
              <Spinner className="custom-spinner" />
            ) : (
              <>
                <Button color="secondary" onClick={toggle}>
                  Cancelar
                </Button>
                <Button color="danger" onClick={handleDelete}>
                  Borrar
                </Button>
              </>
            )}
          </ModalFooter>
        </Modal>
      </td>
    </TableRow>
  );
};

ServicesItem.propTypes = {
  service: PropTypes.object.isRequired,
  getMedicalServices: PropTypes.func.isRequired,
  deleteMService: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  filters: state.locations.filters
});

export default connect(
  mapStateToProps,
  { getMedicalServices, deleteMService }
)(ServicesItem);
